import React, { useState } from 'react';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';
import { Icons } from '../../../components/atoms/SVG';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog.modifier';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PageMembershipMatchingRuleSettingsEditView } from '../views/PageMembershipMatchingRuleSettingsEditView';
import { InstantView } from '../../../types/BlockWithViews';

export function PageMembershipMatchingRuleSettingsEditBar(
  props: InstantView<PageMembershipMatchingRuleSettingsEditView>) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleSettings');
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <BlockBar heading={t('editBarHeading')} hierarchy={3} modifier="border-bottom">
        <BlockBarButton
          text={t('editMatchingRule')}
          svgSpriteId={showModal ? Icons.DECLINE_CROSS : Icons.EDIT_PENCIL}
          onClick={() => setShowModal(true)}
        />
      </BlockBar>
      {showModal
        ? (
            <ModalDialog
              headline={t('editMatchingRule')}
              modifier={ModalDialogModifier.WIDE}
              closeModal={() => setShowModal(false)}
              initialFocusIndex={1}
            >
              <PageMembershipMatchingRuleSettingsEditView {...props} />
            </ModalDialog>
          )
        : null}
    </>
  );
}
